/**
* Tangram Design Tokens v3.2.1
* Code generated by @resultadosdigitais/tangram-design-tokens. DO NOT EDIT.
* Copyright Resultados Digitais. 2020
*/
var version = '3.2.1';
var sizeSpacing01 = '4px';
var sizeSpacing02 = '8px';
var sizeSpacing03 = '12px';
var sizeSpacing04 = '16px';
var sizeSpacing05 = '24px';
var sizeSpacing06 = '32px';
var sizeSpacing07 = '40px';
var sizeSpacing08 = '48px';
var sizeSpacing09 = '56px';
var sizeSpacing10 = '64px';
var sizeSpacing11 = '96px';
var sizeSpacing12 = '160px';
var colorGray100 = '#212429';
var colorGray90 = '#3A4149';
var colorGray80 = '#636E7C';
var colorGray70 = '#7E8A98';
var colorGray60 = '#97A1AC';
var colorGray50 = '#ACB4BD';
var colorGray40 = '#BEC4CB';
var colorGray30 = '#CFD3D8';
var colorGray20 = '#E1E4E8';
var colorGray10 = '#F1F3F5';
var colorWhite = '#FFFFFF';
var colorRed100 = '#4D000E';
var colorRed90 = '#730011';
var colorRed80 = '#990617';
var colorRed70 = '#BF1120';
var colorRed60 = '#E6202A';
var colorRed50 = '#FF4D4F';
var colorRed40 = '#FF7875';
var colorRed30 = '#FFA39E';
var colorRed20 = '#FFCCC7';
var colorRed10 = '#FFF1F0';
var colorYellow100 = '#634605';
var colorYellow90 = '#8A6508';
var colorYellow80 = '#B08913';
var colorYellow70 = '#D6AF22';
var colorYellow60 = '#FDD835';
var colorYellow50 = '#FFE75E';
var colorYellow40 = '#FFF187';
var colorYellow30 = '#FFF8B0';
var colorYellow20 = '#FFFDD9';
var colorYellow10 = '#FFFFF0';
var colorGreen100 = '#002921';
var colorGreen90 = '#004F3D';
var colorGreen80 = '#007556';
var colorGreen70 = '#009C6D';
var colorGreen60 = '#0AC285';
var colorGreen50 = '#2BCF93';
var colorGreen40 = '#51DBA4';
var colorGreen30 = '#7BE8B9';
var colorGreen20 = '#A9F5D1';
var colorGreen10 = '#E6FFF2';
var colorPurple100 = '#120338';
var colorPurple90 = '#22075E';
var colorPurple80 = '#391085';
var colorPurple70 = '#531DAB';
var colorPurple60 = '#722ED1';
var colorPurple50 = '#9254DE';
var colorPurple40 = '#B37FEB';
var colorPurple30 = '#D3ADF7';
var colorPurple20 = '#EFDBFF';
var colorPurple10 = '#F9F0FF';
var colorMidnightblue1 = '#2D0994';
var colorMidnightblue2 = '#431AB6';
var colorMidnightblue3 = '#431AB6';
var colorMidnightblue4 = '#7E5BE2';
var colorOrchid1 = '#7100B7';
var colorOrchid2 = '#880DD3';
var colorOrchid3 = '#A025EB';
var colorOrchid4 = '#BC51FD';
var colorDeepskyblue1 = '#0580F1';
var colorDeepskyblue2 = '#2C9AFF';
var colorDeepskyblue3 = '#5FB2FF';
var colorDeepskyblue4 = '#8DC8FF';
var colorDeeppurple1 = '#730075';
var colorDeeppurple2 = '#822884';
var colorDeeppurple3 = '#9A179C';
var colorDeeppurple4 = '#C42FC7';
var colorDeeppink1 = '#9F0160';
var colorDeeppink2 = '#BD0071';
var colorDeeppink3 = '#D30480';
var colorDeeppink4 = '#DF54A8';
var colorVioletred1 = '#DC2794';
var colorVioletred2 = '#F047AC';
var colorVioletred3 = '#FF5FBF';
var colorVioletred4 = '#FE77C8';
var colorTan1 = '#B76300';
var colorTan2 = '#C7710C';
var colorTan3 = '#DB821A';
var colorTan4 = '#E9993C';
var colorSienna1 = '#EB5D2E';
var colorSienna2 = '#EE7349';
var colorSienna3 = '#FF8B64';
var colorSienna4 = '#FFA081';
var colorGoldenorange1 = '#F4A812';
var colorGoldenorange2 = '#FFC044';
var colorGoldenorange3 = '#FFCD6B';
var colorGoldenorange4 = '#FFDD99';
var colorOlive1 = '#909300';
var colorOlive2 = '#AAAD06';
var colorOlive3 = '#C1C521';
var colorOlive4 = '#D5D839';
var colorSeagreen1 = '#0BB280';
var colorSeagreen2 = '#0BCB91';
var colorSeagreen3 = '#16DCA1';
var colorSeagreen4 = '#28EAB0';
var textFontFamily = "'Nunito Sans', 'Open Sans', Arial, sans-serif";
var textLineHeight = '1.5';
var textLineHeightMd = '1.4';
var textLineHeightSm = '1.3';
var textSizeXxl = '36px';
var textSizeXl = '28px';
var textSizeLg = '20px';
var textSizeMd = '16px';
var textSizeSm = '14px';
var textSizeXs = '12px';
var textWeightRegular = 'normal';
var textWeightBold = 'bold';
var textWeightExtrabold = '800';
var textXxlBold = 'var(--text-weight-bold) var(--text-size-xxl)/46px var(--text-font-family)';
var textXxlExtrabold = 'var(--text-weight-extrabold) var(--text-size-xxl)/46px var(--text-font-family)';
var textXxlRegular = 'var(--text-weight-regular) var(--text-size-xxl)/46px var(--text-font-family)';
var textXlBold = 'var(--text-weight-bold) var(--text-size-xl)/36px var(--text-font-family)';
var textXlExtrabold = 'var(--text-weight-extrabold) var(--text-size-xl)/36px var(--text-font-family)';
var textXlRegular = 'var(--text-weight-regular) var(--text-size-xl)/36px var(--text-font-family)';
var textLgBold = 'var(--text-weight-bold) var(--text-size-lg)/30px var(--text-font-family)';
var textLgExtrabold = 'var(--text-weight-extrabold) var(--text-size-lg)/30px var(--text-font-family)';
var textLgRegular = 'var(--text-weight-regular) var(--text-size-lg)/30px var(--text-font-family)';
var textMdBold = 'var(--text-weight-bold) var(--text-size-md)/24px var(--text-font-family)';
var textMdExtrabold = 'var(--text-weight-extrabold) var(--text-size-md)/24px var(--text-font-family)';
var textMdRegular = 'var(--text-weight-regular) var(--text-size-md)/24px var(--text-font-family)';
var textSmBold = 'var(--text-weight-bold) var(--text-size-sm)/20px var(--text-font-family)';
var textSmExtrabold = 'var(--text-weight-extrabold) var(--text-size-sm)/20px var(--text-font-family)';
var textSmRegular = 'var(--text-weight-regular) var(--text-size-sm)/20px var(--text-font-family)';
var textXsBold = 'var(--text-weight-bold) var(--text-size-xs)/16px var(--text-font-family)';
var textXsExtrabold = 'var(--text-weight-extrabold) var(--text-size-xs)/16px var(--text-font-family)';
var textXsRegular = 'var(--text-weight-regular) var(--text-size-xs)/16px var(--text-font-family)';
var shadowXl = '0px 18px 32px rgba(33, 36, 41, 0.3)';
var shadowLg = '0px 12px 24px rgba(33, 36, 41, 0.2)';
var shadowMd = '0px 8px 18px rgba(33, 36, 41, 0.16)';
var shadowSm = '0px 4px 12px rgba(33, 36, 41, 0.14)';
var shadowXs = '0px 2px 6px rgba(33, 36, 41, 0.1)';
var borderRadiusRounded = '2px';
var borderRadiusCircle = '50%';
var borderRadiusPill = '999px';
var motionDurationExtraFast = '100ms';
var motionDurationFast = '200ms';
var motionDurationNormal = '300ms';
var motionDurationSlow = '400ms';
var motionDurationExtraSlow = '500ms';
var motionDurationUltraSlow = '1000ms';
var motionTimingFunctionEaseIn = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
var motionTimingFunctionEaseOut = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
var motionTimingFunctionEaseInOut = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
var breakpointXs = '480px';
var breakpointSm = '768px';
var breakpointMd = '1024px';
var breakpointLg = '1280px';
var breakpointXl = '1440px';
var breakpointMax = '1920px';
var zindexAuto = 'auto';
var zindex0 = '1';
var zindex1 = '1000';
var zindex2 = '1010';
var zindex3 = '1020';
var zindex4 = '1030';
var zindex5 = '1040';
var zindex6 = '1050';
var zindexBack = '-1';
var themes = {
  lina: 'lina',
  crm: 'crm',
  marketing: 'marketing'
};

var tangramDesignTokens = function tangramDesignTokens(theme) {
  var themeVariables = {
    lina: {
      colorPrimary10: '#EBFDFF',
      colorPrimary20: '#CAFAFC',
      colorPrimary30: '#9FF2F5',
      colorPrimary40: '#78EDF2',
      colorPrimary50: '#3BE5EB',
      colorPrimary60: '#19C1CE',
      colorPrimary70: '#11A7B6',
      colorPrimary80: '#008096',
      colorPrimary90: '#005E72',
      colorPrimary100: '#0B485B'
    },
    crm: {
      colorPrimary10: '#E6FBFF',
      colorPrimary20: '#A6EFFF',
      colorPrimary30: '#7DE3FF',
      colorPrimary40: '#54D4FF',
      colorPrimary50: '#2BC3FF',
      colorPrimary60: '#03A9F4',
      colorPrimary70: '#0086CF',
      colorPrimary80: '#0068A8',
      colorPrimary90: '#004C82',
      colorPrimary100: '#00325C'
    },
    marketing: {
      colorPrimary10: '#E6F6FF',
      colorPrimary20: '#B8E2FF',
      colorPrimary30: '#8FCEFF',
      colorPrimary40: '#63B2F7',
      colorPrimary50: '#3891EB',
      colorPrimary60: '#1272DE',
      colorPrimary70: '#0653B8',
      colorPrimary80: '#003A91',
      colorPrimary90: '#00276B',
      colorPrimary100: '#001745'
    }
  };

  if (!themeVariables.hasOwnProperty(theme)) {
    console.error('Property ' + theme + ' does not exist!');
    return;
  }

  return themeVariables[theme];
};

export default tangramDesignTokens;
export { borderRadiusCircle, borderRadiusPill, borderRadiusRounded, breakpointLg, breakpointMax, breakpointMd, breakpointSm, breakpointXl, breakpointXs, colorDeeppink1, colorDeeppink2, colorDeeppink3, colorDeeppink4, colorDeeppurple1, colorDeeppurple2, colorDeeppurple3, colorDeeppurple4, colorDeepskyblue1, colorDeepskyblue2, colorDeepskyblue3, colorDeepskyblue4, colorGoldenorange1, colorGoldenorange2, colorGoldenorange3, colorGoldenorange4, colorGray10, colorGray100, colorGray20, colorGray30, colorGray40, colorGray50, colorGray60, colorGray70, colorGray80, colorGray90, colorGreen10, colorGreen100, colorGreen20, colorGreen30, colorGreen40, colorGreen50, colorGreen60, colorGreen70, colorGreen80, colorGreen90, colorMidnightblue1, colorMidnightblue2, colorMidnightblue3, colorMidnightblue4, colorOlive1, colorOlive2, colorOlive3, colorOlive4, colorOrchid1, colorOrchid2, colorOrchid3, colorOrchid4, colorPurple10, colorPurple100, colorPurple20, colorPurple30, colorPurple40, colorPurple50, colorPurple60, colorPurple70, colorPurple80, colorPurple90, colorRed10, colorRed100, colorRed20, colorRed30, colorRed40, colorRed50, colorRed60, colorRed70, colorRed80, colorRed90, colorSeagreen1, colorSeagreen2, colorSeagreen3, colorSeagreen4, colorSienna1, colorSienna2, colorSienna3, colorSienna4, colorTan1, colorTan2, colorTan3, colorTan4, colorVioletred1, colorVioletred2, colorVioletred3, colorVioletred4, colorWhite, colorYellow10, colorYellow100, colorYellow20, colorYellow30, colorYellow40, colorYellow50, colorYellow60, colorYellow70, colorYellow80, colorYellow90, motionDurationExtraFast, motionDurationExtraSlow, motionDurationFast, motionDurationNormal, motionDurationSlow, motionDurationUltraSlow, motionTimingFunctionEaseIn, motionTimingFunctionEaseInOut, motionTimingFunctionEaseOut, shadowLg, shadowMd, shadowSm, shadowXl, shadowXs, sizeSpacing01, sizeSpacing02, sizeSpacing03, sizeSpacing04, sizeSpacing05, sizeSpacing06, sizeSpacing07, sizeSpacing08, sizeSpacing09, sizeSpacing10, sizeSpacing11, sizeSpacing12, textFontFamily, textLgBold, textLgExtrabold, textLgRegular, textLineHeight, textLineHeightMd, textLineHeightSm, textMdBold, textMdExtrabold, textMdRegular, textSizeLg, textSizeMd, textSizeSm, textSizeXl, textSizeXs, textSizeXxl, textSmBold, textSmExtrabold, textSmRegular, textWeightBold, textWeightExtrabold, textWeightRegular, textXlBold, textXlExtrabold, textXlRegular, textXsBold, textXsExtrabold, textXsRegular, textXxlBold, textXxlExtrabold, textXxlRegular, themes, version, zindex0, zindex1, zindex2, zindex3, zindex4, zindex5, zindex6, zindexAuto, zindexBack };